import React, { useEffect, useState } from 'react'
import { Form } from 'semantic-ui-react'
import { FormFields } from '~/components/FormFields'
import { StyledGroupQuestion } from '~/pages/Dairy/Survey/ShowSurvey/CreateEditQuestion/style'
import cloneDeep from 'lodash.clonedeep'
import { useTranslation } from 'react-i18next'
import notify from '~/components/Notify'

interface GroupedQuestionsProps {
  control: any
  question: any
  setValue: any
  activeIndex: string | number
  getValues: any
  clearErrors: any
  isSubmitted: boolean
}

const GroupedQuestions: React.FC<GroupedQuestionsProps> = (props) => {
  const { t } = useTranslation()
  const {
    control,
    setValue,
    question,
    activeIndex,
    getValues,
    clearErrors,
    isSubmitted
  } = props
  const [checked, setChecked] = useState([])
  const errorMessage = t('Please answer all questions')

  useEffect(() => {
    const value = cloneDeep(getValues(`questions[${activeIndex}].groupQuestions`))
    const id = getValues(`questions[${activeIndex}].id`)
    if (!id) {
      setValue(`questions[${activeIndex}].id`, question.id)
    }
    const answers = []
    value?.map((question, index) => question.answers?.map(answer => {
      if (answer.answerId) {
        answers.push(props.question.groupQuestions[index]?.id + answer.answerId)
      }
    }))
    if (answers.length > 0) {
      setChecked(answers)
    }
  }, [question, activeIndex])

  function renderSubQuestions() {
    return question?.groupQuestions.map((subQuestion, questionIndex) => {
      return <div key={subQuestion.id} style={{ display: 'flex' }}>
        <StyledGroupQuestion
          label={subQuestion.question}
        />
        <Form.Group widths={'equal'}>
          {question?.answers?.map((answer, answerIndex) => {
            return <Form.Field key={subQuestion.id + answer.id} style={{ textAlign: 'center', whiteSpace: 'nowrap' }}>
              <div className='radio-container'>
                <label>{answer.answer}</label>
                <FormFields.External
                  control={control}
                  noErrorMessage
                  onChange={() => {
                    const temp = [...checked]
                    temp[questionIndex] = subQuestion.id + answer.id
                    setChecked(temp)
                    setValue(`questions[${activeIndex}].groupQuestions[${questionIndex}].answers`, [{ answerId: answer.id }])
                    if (question?.required && temp.length === question?.groupQuestions?.length && isSubmitted) {
                      clearErrors(`questions[${activeIndex}].groupQuestions[${questionIndex}].answers[0].answerId`)
                    }
                  }}
                  rules={{
                    validate: () => {
                      if (question?.required && questionIndex === 0) {
                        if (question?.groupQuestions?.length === checked.length) {
                          return true
                        }
                        notify(errorMessage, 'error')
                        return false
                      }
                      return true
                    }
                  }}
                  id={subQuestion.id + answer.id}
                  name={`questions[${activeIndex}].groupQuestions[${questionIndex}].answers[0].answerId`}
                >
                  <Form.Checkbox
                    radio
                    checked={checked[questionIndex] == subQuestion.id + answer.id}
                    style={{ marginTop: 3 }}
                  />
                </FormFields.External>
              </div>
            </Form.Field>
          })}
        </Form.Group>
      </div>
    })
  }

  return <>
    <Form.Field label={question?.question} required={Boolean(question?.required)} />
    {renderSubQuestions()}
  </>
}
export default GroupedQuestions